import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { Typography, notification } from 'antd';
import { ChallengeForm } from './ChallengeForm';
import { ChallengesProxy } from '../services/catalogServiceAPI/challengesProxy';

export function CreateChallenge() {
    const history = useHistory();
    const proxy = useMemo(() => new ChallengesProxy(), []);

    const submit = async (values) => {
        const created = await proxy.create(values);
        notification.success({ message: 'Challenge created' });
        history.push(`/challenges/edit/${created.id}`);
    };

    return (
        <div style={{ padding: '24px 32px', maxWidth: 900 }}>
            <Typography.Title level={3}>New challenge</Typography.Title>
            <ChallengeForm onSubmit={submit} submitLabel="Create challenge" enableSuggest />
        </div>
    );
}
